// extracted by mini-css-extract-plugin
module.exports = {"ptoTable":"style__ptoTable__HpsnR"};